import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable()
export class UploadInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (
      req.url.indexOf("/NotificacionesMasivasAdministrador/RedactarMensaje") === -1 &&
      req.url.indexOf("/Sanciones/Crear") === -1 &&
      req.url.indexOf("/ExpedirCertificado") === -1 &&
      req.url.indexOf("/Archivo/SubirDocumento") === -1 &&
      req.url.indexOf("/ExpedirCertificadoRegistro") === -1 &&
      req.url.indexOf("/sanciones/CambiarEstadoSancion") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarRnt") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarTramites") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarReporteSancionesPersonas") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarPrestador") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarEstadistico") === -1 &&
      req.url.indexOf("/sanciones/descargarDocumentoSancion") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarInformeFontur") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarSicSolicitudes") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarInformeEncuentas") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarEstablecimientos") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarPagosParafiscales") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarInformeAnotaciones") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarInformeCantidadRnt") === -1 &&
      req.url.indexOf("/DocumentoDetalleSolicitud/DescargarDocumento") === -1 &&
      req.url.indexOf("/Reporte/GenerarExportarReporteProductividad") === -1 &&
      req.url.indexOf("Reporte/GenerarExportarInformeCantidadRntEstado") ===
        -1 &&
      req.url.indexOf("/ContenidoCertificadoAdministrador/SubirDocumento") ===
        -1 &&
      req.url.indexOf("/ContenidoCertificado/ObtenerRecurso") === -1
    ) {
      return next.handle(req);
    }
    let fileReq = req.clone({
      responseType: "blob",
    });

    if (
      req.url.indexOf("/NotificacionesMasivasAdministrador/RedactarMensaje") > -1 ||
      req.url.indexOf("/Sanciones/Crear") > -1 ||
      req.url.indexOf("/Archivo/SubirDocumento") > -1 ||
      req.url.indexOf("/sanciones/CambiarEstadoSancion") > -1 ||
      req.url.indexOf("/ContenidoCertificadoAdministrador/SubirDocumento") > -1
    ) {
      fileReq = req.clone({
        reportProgress: true,
      });
    }
    return next.handle(fileReq);
  }
}
